export default __webpack_public_path__ + "static/media/336.f3b17115.jpg";